<div class="modal-header">
    <h5 class="modal-title">Assign a crew</h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="cancel()"></button>
</div>

<div class="modal-body">
    <div class="mb-3">
        <label class="form-label">Job</label>
        <div>{{ context.jobLabel }}</div>
    </div>

    <div class="mb-3">
        <label class="form-label" for="job-assign-foreman">Foreman</label>
        <select
            id="job-assign-foreman"
            class="form-select"
            [ngModel]="foremanHrRef()"
            (ngModelChange)="foremanHrRef.set($event)"
        >
            <option [ngValue]="0">Select foreman…</option>
            @for (foreman of context.foremen; track foreman.hrRef) {
                <option [ngValue]="foreman.hrRef">{{ foreman.name }} — {{ foreman.jobTitle }}</option>
            }
        </select>
    </div>

    <div class="mb-3">
        <label class="form-label" for="job-assign-start-date">Start date</label>
        <input
            id="job-assign-start-date"
            type="date"
            class="form-control"
            [ngModel]="startDate()"
            (ngModelChange)="startDate.set($event)"
        />
    </div>

    <div class="mb-3">
        <label class="form-label" for="job-assign-phase">Phase</label>
        <select
            id="job-assign-phase"
            class="form-select"
            [ngModel]="phase()"
            (ngModelChange)="phase.set($event)"
            [disabled]="loadingPhases() || !phases().length"
        >
            <option value="">
                @if (loadingPhases()) {
                    Loading phases…
                } @else if (!phases().length) {
                    No phases available
                } @else {
                    Select phase…
                }
            </option>
            @for (p of phases(); track p.phase) {
                <option [value]="p.phase">{{ phaseLabel(p) }}</option>
            }
        </select>
    </div>

    <div class="mb-3">
        <label class="form-label" for="job-assign-days">Days (optional)</label>
        <input
            id="job-assign-days"
            type="number"
            min="1"
            step="1"
            class="form-control"
            placeholder="Leave blank to schedule by remaining hours"
            title="Force the crew onto this phase for a set number of working days, even after its remaining hours run out."
            [ngModel]="forcedDays()"
            (ngModelChange)="forcedDays.set($event === '' || $event == null ? null : $event)"
        />
    </div>

    @if (overlapWarning()) {
        <div class="alert alert-warning py-2 mb-3" role="status">{{ overlapWarning() }}</div>
    }

    @if (error()) {
        <p class="text-danger mb-0">{{ error() }}</p>
    }
</div>

<div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="cancel()">Cancel</button>
    <button
        type="button"
        class="btn btn-primary"
        [disabled]="loadingPhases()"
        (click)="save()"
    >
        Add assignment
    </button>
</div>
